import { create } from "zustand";
import { getRole } from "@/http/getRole";

export const useRoleStore = create((set) => ({
  role: undefined,
  isAdmin: false,
  roleCheck: false,

  fetchRole: async () => {
    try {
      const user = localStorage.getItem("secretaria_user");

      if (!user) {
        set({ roleCheck: true });
        return;
      }

      const user_json = JSON.parse(user);
      const role = await getRole(user_json.token);
      set({
        role,
        isAdmin: role === "Administrador",
        roleCheck: true,
      });
    } catch (error) {
      console.error("Erro ao buscar role:", error);
      set({ roleCheck: true });
    }
  },
}));
